import { useMemo } from 'react';
import { cloneTracker } from '../utils/UsageTracker';
export const useTracker = (trackerInstance, usageTrackerLocation) => {
  const aiTracker = useMemo(() => {
    return cloneTracker(trackerInstance, usageTrackerLocation);
  }, [trackerInstance, usageTrackerLocation]);
  return {
    aiTracker
  };
};